import { Component, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { ShowComponent } from 'src/app/common/component/show.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { OfferTransportKind } from '@/common/enums/OfferTransportKind';
import { StopsMap, TransportStops } from '../stop.models';
import { Location } from '@/new-transport/_models/transport.model';
import { StopKind } from '@/common/enums/BagTransport';

@Component({
	selector: 'app-stop',
	templateUrl: './stop.component.html',
	styleUrls: ['./stop.component.css'],
})
export class StopComponent extends ShowComponent implements OnInit {
	apiType = 'bag';
	apiUrlAdd = '/transport/stop/';
	parentComponent = 'stop';
	pageTitle = 'Przystanki';
	pageFunction = 'edit';
	parentLocationSet: Location[] = [];
	parentStopSet: TransportStops[] = [];

	transportStops: StopsMap[] = [
		{ value: 'BA', name: 'Wsiadkowy' },
		{ value: 'BR', name: 'Graniczny' },
		{ value: 'CR', name: 'Przelotowy' },
		{ value: 'DO', name: 'Wysiadkowy' },
		{ value: 'TG', name: 'Docelowy' },
	];

	data = {
		id: null,
		parentStop: null,
		name: null,
		stopType: null,
		address: null,
		location: null,
		longitude: null,
		latitude: null,
		erpGrid: [],
		kind: null,
		iataCode: null,
	};

	readonly kind = signal<OfferTransportKind>(null);
	readonly OfferTransportKind = OfferTransportKind;

	private locationName = '';

	private readonly destroyRef = inject(DestroyRef);

	ngOnInit(): void {
		this.route.params.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((p) => {
			if (p.kind) {
				this.data.kind = p.kind;
				this.kind.set(p.kind);
				if (this.kind() === OfferTransportKind.PLANE) {
					this.pageTitle = 'Lotniska';
				}
			}
			super.ngOnInit();
		});
	}

	loadBefore(): void {
		this.bag.get('/transport/stop/?limit=9999', (result, error) => {
			if (error) {
				this.loader.hide();
				return;
			}
			this.parentStopSet = result.results;
		});

		this.bag.get('/location/?limit=9999', (result, error) => {
			if (error) {
				this.loader.hide();
				return;
			}
			this.parentLocationSet = result.results;
		});
		this.loadData();
	}

	// eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
	convertData(data: any): any {
		if (data.erpGrid === null) {
			data.erpGrid = [];
		}
		this.locationName = data.location.name;
		data.location = data.location.id;
		return data;
	}

	getApiUrl(): string {
		return '/transport/stop/' + this.data.id + '/';
	}

	pageTitleGenerate(): string {
		return this.locationName + ' (ID: ' + this.data.id + ')';
	}

	submitBefore(): void {
		if (this.data.stopType === StopKind.TARGET) {
			this.data.kind = null;
		}
	}

	// eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
	afterSend(result: any, error: any): void {
		this.loader.hide();
		if (error) {
			return;
		}

		if (this.pageFunction === 'add') {
			this.router.navigate([`/stop/${this.kind()}/${this.data.id}`]);
		}

		this.pageFunction = 'edit';
		this.editable = false;
		this.pageTitle = this.pageTitleGenerate();
		this.apiUrl = this.getApiUrl();
		this.infobox.success('Zapisano');
		this.submitAfter();
	}
}
